import axiosClient from './axiosClient'
import { STOCK_ALERT_ENDPOINTS } from './endpoints'

const unwrap = data => data?.data ?? data

export const fetchActiveAlerts = async () => {
  const { data } = await axiosClient.get(STOCK_ALERT_ENDPOINTS.LIST)
  return unwrap(data)
}

export const fetchAlertsByProduct = async productId => {
  const { data } = await axiosClient.get(STOCK_ALERT_ENDPOINTS.BY_PRODUCT(productId))
  return unwrap(data)
}

